module.exports = __webpack_public_path__ + "img/1728545082991-Screenshot_10-10-2024_152429_www.bing.com.jpeg.c06cc793.webp";